__webpack_require__.p = "/playtomic-challenge/";